// src/components/contracts/Contracts.jsx


import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Button,
  Grid,
} from '@mui/material';
import LeaseToOwnStyles from './LeaseToOwnStyles';

const propertyTypes = ['Condo', 'Single Family', 'Multifamily'];

const LeaseToOwnForm = () => {
  const [formData, setFormData] = useState({
    propertyAddress: '',
    propertyType: '',
    unitCount: '',
    ownerName: '',
    socialOrEIN: '',
    dob: '',
    shippingAddress: '',
    schlageCount: '',
    digitalLockCount: '',
    blinkCount: '',
    internetProvider: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Lease-To-Own Form submitted:', formData);
    alert('Lease-To-Own financing details submitted successfully!');
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <Box sx={LeaseToOwnStyles.container}>
      <Typography variant="h3" sx={LeaseToOwnStyles.title}>
        Lease-To-Own Financing Application
      </Typography>

      <Typography variant="body1" sx={LeaseToOwnStyles.description}>
        We offer financing for the most compatible and best-supported equipment to ensure top-notch keyless access and monitoring.  
        Most property owners will qualify after verification. **No hard credit inquiry.**  
        Full packages average **$25 per month for 36 months**, with lease payments starting **the month after approval**.
      </Typography>

      <Box component="form" onSubmit={handleSubmit} sx={LeaseToOwnStyles.form}>
        {/* Property Address */}
        <TextField
          label="Property Address"
          name="propertyAddress"
          value={formData.propertyAddress}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
        />

        {/* Property Type */}
        <TextField
          select
          label="Property Type"
          name="propertyType"
          value={formData.propertyType}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
        >
          {propertyTypes.map((type) => (
            <MenuItem key={type} value={type}>
              {type}
            </MenuItem>
          ))}
        </TextField>

        {/* Unit Count */}
        <TextField
          label="Number of Units"
          name="unitCount"
          type="number"
          value={formData.unitCount}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
        />

        {/* Owner Name */}
        <TextField
          label="Owner/Entity Name"
          name="ownerName"
          value={formData.ownerName}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
        />

        {/* Social Security/EIN */}
        <TextField
          label="Social Security or EIN"
          name="socialOrEIN"
          value={formData.socialOrEIN}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
        />

        {/* Date of Birth */}
        <TextField
          label="Date of Birth"
          name="dob"
          type="date"
          value={formData.dob}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
          InputLabelProps={{ shrink: true }}
        />

        {/* Shipping Address */}
        <TextField
          label="Shipping Address (Specify location type & instructions)"
          name="shippingAddress"
          value={formData.shippingAddress}
          onChange={handleChange}
          fullWidth
          required
          multiline
          rows={3}
          sx={LeaseToOwnStyles.input}
        />

        <Typography variant="h5" sx={LeaseToOwnStyles.sectionTitle}>
          Product Listings
        </Typography>

        {/* Schlage Locks */}
        <TextField
          label="Schlage Locks (How many?)"
          name="schlageCount"
          type="number"
          value={formData.schlageCount}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
        />

        {/* Digital Locks */}
        <TextField
          label="Digital Locks (Back Doors/Side Doors - How many?)"
          name="digitalLockCount"
          type="number"
          value={formData.digitalLockCount}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
        />

        {/* Blink Doorbell System */}
        <TextField
          label="Blink Doorbell System & Echo Pop (How many?)"
          name="blinkCount"
          type="number"
          value={formData.blinkCount}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
        />

        {/* Internet Provider */}
        <TextField
          label="Internet Service Provider for Property"
          name="internetProvider"
          value={formData.internetProvider}
          onChange={handleChange}
          fullWidth
          required
          sx={LeaseToOwnStyles.input}
        />

        {/* Buttons */}
        <Grid container spacing={2} sx={LeaseToOwnStyles.buttonContainer}>
          <Grid item xs={6}>
            <Button type="submit" variant="contained" sx={LeaseToOwnStyles.submitButton}>
              Submit Online
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button variant="outlined" onClick={handlePrint} sx={LeaseToOwnStyles.printButton}>
              Print Form
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default LeaseToOwnForm;
